import { useState, useEffect } from "react";
import { isNative } from "../../lib/capacitor";

declare const __NATIVE_VERSION__: string;

/**
 * Vérifie si une mise à jour du binaire natif est disponible.
 * Compare la version native embarquée dans le build avec celle
 * attendue par le serveur via /api/health.
 */
export function NativeUpdateBanner() {
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!isNative) return;

    const currentNativeVersion = __NATIVE_VERSION__;
    const dismissedVersion = localStorage.getItem("palnia_native_update_dismissed");

    fetch("/api/health")
      .then((r) => r.json())
      .then((data: { nativeVersion?: string; nativeDownloadUrl?: string }) => {
        if (
          data.nativeVersion &&
          data.nativeDownloadUrl &&
          data.nativeVersion !== currentNativeVersion &&
          data.nativeVersion !== dismissedVersion
        ) {
          setDownloadUrl(data.nativeDownloadUrl);
        }
      })
      .catch(() => { /* réseau indisponible */ });
  }, []);

  if (!downloadUrl || dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    // Ne pas re-afficher pour cette version pendant 24h
    fetch("/api/health")
      .then((r) => r.json())
      .then((data: { nativeVersion?: string }) => {
        if (data.nativeVersion) {
          localStorage.setItem("palnia_native_update_dismissed", data.nativeVersion);
        }
      })
      .catch(() => {});
  };

  const handleDownload = () => {
    window.open(downloadUrl, "_system");
  };

  return (
    <div className="fixed bottom-20 md:bottom-6 left-1/2 -translate-x-1/2 z-[100] animate-slide-up w-[calc(100%-2rem)] max-w-sm">
      <div className="flex flex-col gap-2 bg-surface border border-border rounded-xl shadow-xl px-4 py-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex flex-col gap-0.5">
            <p className="text-sm text-ink font-medium">
              Nouvelle version disponible
            </p>
            <p className="text-xs text-ink-muted">
              Téléchargez la dernière version pour profiter des améliorations.
            </p>
          </div>
          <button
            type="button"
            onClick={handleDismiss}
            className="shrink-0 text-ink-muted hover:text-ink text-xs"
            aria-label="Fermer"
          >
            ✕
          </button>
        </div>
        <button
          type="button"
          onClick={handleDownload}
          className="w-full px-3 py-2 text-xs font-semibold bg-accent text-white rounded-lg hover:opacity-80 transition-opacity"
        >
          Télécharger la mise à jour
        </button>
      </div>
    </div>
  );
}
